import React from "react";
import styled from "styled-components";
import InnerContentWrapper from "../styles/InnerContentWrapper";
import { Link } from "react-router-dom";
import CoursePreview from "../coursepage/course/CoursePreview";
import { SHOPIFY_URL } from "../../config";

const StyledPurchaseList = styled.div``;

const PurchaseList = ({ allCourses, userData }) => {
  let myCourses = [];
  let buyCourses = allCourses;

  if (userData) {
    myCourses = allCourses.filter(
      (course) => userData.ownedCourses.indexOf(course.contentfulCourseId) > -1
    );
    buyCourses = allCourses.filter(
      (course) => userData.ownedCourses.indexOf(course.contentfulCourseId) < 0
    );
  }

  return (
    <StyledPurchaseList>
      <InnerContentWrapper>
        {myCourses.length > 0 && (
          <div className="myCourses coursePreviewContainer">
            <h2>My Courses</h2>
            {myCourses.map((course) => (
              <CoursePreview
                key={course.contentfulCourseId}
                courseId={course.contentfulCourseId}
                courseImage={course.courseImage}
                courseTitle={course.courseName}
                courseDescription={course.courseDescription}
              >
                <Link
                  to={`/course/${course.contentfulCourseId}`}
                  className="courseLink"
                >
                  Go To Course
                </Link>
              </CoursePreview>
            ))}
          </div>
        )}
        <div className="buyCourses coursePreviewContainer">
          <h2>Buy Courses</h2>
          {buyCourses.length > 0 ? (
            buyCourses.map((course) => (
              <CoursePreview
                key={course.contentfulCourseId}
                courseId={course.contentfulCourseId}
                courseImage={course.courseImage}
                courseTitle={course.courseName}
                courseDescription={course.courseDescription}
              >
                <a
                  href={`${SHOPIFY_URL}/products/${course.slug}`}
                  className="courseLink"
                >
                  See Details
                </a>
              </CoursePreview>
            ))
          ) : (
            <div>You own all available courses</div>
          )}
        </div>
      </InnerContentWrapper>
    </StyledPurchaseList>
  );
};

export default PurchaseList;
